type Props = {
    children: any
}

const ModalFooter = (props: Props) => {
    return (
        <div className="modal-footer">
            {props.children}
        </div>
    );
};

export default ModalFooter;
